// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "#V-111A6B5E-7904-4C93-AD87-8356DE89910B {\n  border: 1px black dashed;\n}\n", "",{"version":3,"sources":["webpack://src/formBuilder/components/dummyPlaceHolder/dummyTablePlaceHolderComponent/tdDecorator/tdDecorator.less"],"names":[],"mappings":"AAAA;EACI,wBAAA;AACJ","sourcesContent":["#V-111A6B5E-7904-4C93-AD87-8356DE89910B{\n    border: 1px black dashed;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
